export const en = {
    'title': 'Template list',
    'new-template': 'New template',
    'create': 'Create'
};
